import './polyfill';

import ReactDOM from 'react-dom';

import { ApolloProvider } from '@apollo/client';

import client from './apollo';
import { RouterProvider } from 'react-router-dom';
import { appRouter } from './routes';

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
	window.addEventListener('load', () => navigator.serviceWorker.register('/service-worker.js'));
}

ReactDOM.render(
	<ApolloProvider client={client}>
		<RouterProvider router={appRouter} />
	</ApolloProvider>,
	document.getElementById('root')
);
